import Vue from 'vue'
import Vuex from 'vuex'
import VuePersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

const store = new Vuex.Store({
  plugins: [VuePersistedState({
    paths: ['stateToken', 'accessToken', 'refreshToken', 'expiresIn', 'user', 'userHomeLanguage', 'homeData']
  })],
  state: {
    stateToken: null,
    accessToken: null,
    refreshToken: null,
    expiresIn: null,
    user: null,
    userHomeLanguage: null,
    homeData: null
  },
  mutations: {
    setStateToken: function (state, stateToken) {
      state.stateToken = stateToken
    },
    setAccessToken: function (state, accessToken) {
      state.accessToken = accessToken
    },
    setRefreshToken: function (state, refreshToken) {
      state.refreshToken = refreshToken
    },
    setExpiresIn: function (state, expiresIn) {
      state.expiresIn = expiresIn
    },
    setUser: function (state, user) {
      state.user = user
    },
    setUserHomeLanguage: function (state, userHomeLanguage) {
      state.userHomeLanguage = userHomeLanguage
    },
    setHomeData: function (state, homeData) {
      state.homeData = homeData
    }
  },
  getters: {
    getStateToken: state => {
      return state.stateToken
    },
    getAccessToken: state => {
      return state.accessToken
    },
    getRefreshToken: state => {
      return state.refreshToken
    },
    getExpiresIn: state => {
      return state.expiresIn
    },
    getUser: state => {
      return state.user
    },
    getUserHomeLanguage: state => {
      return state.userHomeLanguage
    },
    getHomeData: state => {
      return state.homeData
    }
  }
})

export default store



// WEBPACK FOOTER //
// ./src/store/index.js